<div class="my-company-wrapper">
  <div class="row">
    <div class="col-12">
      <h3>{{ 'MY_ACCOUNT' | translate }}</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <lib-gung-tabset #ngbTab="gungTabset" orientation="vertical">
        <lib-gung-tab id="tab-info">
          <ng-template libGungTabTitle>
            <div class="tab-title">
              <i class="fa-solid fa-user"></i>
              <span>{{ 'MY_ACCOUNT' | translate }}</span>
            </div>
          </ng-template>
          <ng-template libGungTabContent>
            <div *ngIf="currentUser" class="row">
              <div class="user-info mb-4">
                <h5>{{ 'ACCOUNT_DETAILS' | translate }}</h5>
                <div class="user-details">
                  <div class="mb-2">
                    <strong>{{ 'NAME' | translate }}</strong
                    >: {{ currentUser.name }}
                  </div>
                  <div class="mb-2">
                    <strong>{{ 'EMAIL' | translate }}</strong
                    >: {{ currentUser.email }}
                  </div>
                </div>
              </div>

              <h5>{{ 'MFA' | translate }}</h5>
              <h6>{{ 'DEVICES' | translate }}</h6>
              <p class="text-muted small mb-3">{{ 'MFA_DEVICES_DESCRIPTION' | translate }}</p>
              <div class="devices-list mb-2">
                <div class="row">
                  <div class="col-12 col-md-8 col-lg-6">
                    @for (mfa of currentUser.mfaOptions; track mfa.id) {
                      @if (mfa.status !== 'PENDING_VERIFICATION') {
                        <div class="device-card mb-3 p-3 border rounded">
                          <div class="device-info mb-3 d-flex">
                            <div class="device-icon me-3 d-flex align-items-center">
                              <i class="fa-solid fa-mobile-screen fa-3x text-muted"></i>
                            </div>
                            <div class="device-details flex-grow-1">
                              <div class="device-field mb-2">
                                <div class="field-label small text-muted mb-1">
                                  {{ 'MFA_DEVICE_DESCRIPTION' | translate }}
                                </div>
                                <div class="device-name">{{ mfa.deviceName }}</div>
                              </div>
                              <div class="device-field">
                                <div class="field-label small text-muted mb-1">{{ 'MFA_ADDED_AT' | translate }}</div>
                                <div class="device-date">{{ mfa.createdAt | date: dateUtilService.dateFormat }}</div>
                              </div>
                            </div>
                          </div>
                          <gung-button
                            classes="btn-danger w-100"
                            label="{{ 'DELETE' | translate }}"
                            [onClick]="deleteMfaDevice.bind(this, mfa.id)"
                          />
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-8 col-lg-6">
                  <gung-button
                    classes="btn-primary w-100"
                    label="{{ 'ADD_NEW_MFA' | translate }}"
                    [onClick]="addMfaDevice.bind(this)"
                  />
                </div>
              </div>
            </div>
          </ng-template>
        </lib-gung-tab>
      </lib-gung-tabset>
    </div>
  </div>
</div>
